import { Component, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../service/action-window.service';
import { FormControlExFactory } from '../../service/factory/form-control-ex-factory.service';
import { LanguageService } from '../../service/language.service';
import { TranslateTextBoxComponent } from '../translate-text-box/translate-text-box.component';

@Component({
    selector: 'translate-text-area',
    templateUrl: './translate-text-area.component.html',
    styleUrls: ['./translate-text-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TranslateTextAreaComponent extends TranslateTextBoxComponent {
  constructor(
    languageService: LanguageService,
    fcf: FormControlExFactory,
    injector: Injector,
    dialogService: ActionWindowService
  ) {
    super(languageService, fcf, injector, dialogService);
  }
  @Input() rows: number = 5;
}
